import { createEl } from 'lmnt';

export default class Progress {
  constructor(state) {
    this.state = state;
    this.beacons = this.state.views;
    this.indicators = {};

    this.el = createEl('div', { className: 'airplane-progress hidden' });

    this.frame = createEl('img', { className: 'airplane-progress-frame', src: 'assets/images/BeaconsLeftNav3_ru.svg' }); // ru translation
    this.frame.setAttribute("alt", "Beacons Reached: 0 of 4.");      
    this.el.appendChild(this.frame);

    const wrapper = createEl('div', { className: 'airplane-progress-wrapper' });
    this.el.appendChild(wrapper);

    this.state.views.forEach((view) => {
        if (!view.menuOnly) {
          
        const indicator = createEl('img', { className: 'airplane-progress-indicator inactive ' + view.name, src: 'assets/images/Beacon.svg' });
        this.indicators[view.name] = indicator;
        wrapper.appendChild(indicator);
      }
    });
  }


  updateView(previous) {
      if (previous !== null && previous in this.indicators) {
          //var tester;
          setTimeout(function () {
               
              let visitedBeacon = localStorage.getItem('visited-beacon');
              let progressBeacon = document.querySelectorAll(".airplane-progress-indicator");
             // let cueOutro = true;
            


              for (var i = 0; i < progressBeacon.length; i++) {
                  if ((progressBeacon[i].classList.contains(visitedBeacon))) {
                      progressBeacon[i].classList.remove('inactive');
                  }


              }

             

             
          }, 50);

           

        //this.indicators[previous].classList.remove('inactive');

      const visitedBeacons = this.state.views.filter((x) => x.visited);
          this.frame.setAttribute("alt", `Beacons Reached: ${visitedBeacons.length} of 4.`); 


         
    }
  } 

  updateFlow(previous, current) {
      if (current === 'flying') this.el.classList.remove('hidden');

  } 
  
    resetAll() {


        let outro_state = localStorage.getItem('state'); 

         
      //  if (outro_state == "revisit") {
        let o = this.el.querySelectorAll('.airplane-progress-indicator');
      

        let dataTab = document.querySelectorAll('.tabbed input');

        [].forEach.call(dataTab, function (elTab) {
            elTab.classList.remove("tab-visited");
        });


            //for (var i = 0; i < o.length; i++) {
            //    o[i].classList.add('inactive');
            //}
//	}	  	
  }
}
